import gql from 'graphql-tag'
export default gql`mutation deleteConsistencyClassMutation($consistencyClassId: Int!) {
  deleteConsistencyClass(consistencyClassId: $consistencyClassId) {
    success
  }
}`